import { getAccess } from "../../server/index";

export const doCookiesExist = () => {
  return document.cookie.match(new RegExp(`(^| )MDO_User=([^;]+)`)) &&
    document.cookie.match(new RegExp(`(^| )MDO_Password=([^;]+)`))
    ? true
    : false;
};

export const getCookies = () => {
  const user = document.cookie.match(new RegExp(`(^| )MDO_User=([^;]+)`));
  const password = document.cookie.match(
    new RegExp(`(^| )MDO_Password=([^;]+)`)
  );
  return {
    username: user ? user[2] : null,
    password: password ? password[2] : null
  };
};

export const verifyCookies = () =>
  new Promise((resolve, reject) => {
    getAccess(getCookies()).then(({ success, profile, ...rest }) => {
      if (success === true) resolve({ _access: true, _profile: profile });
      else resolve({ _access: false, _profile: null });
    });
  });

export default { doCookiesExist, getCookies, verifyCookies };
